module.exports = __webpack_public_path__ + "static/media/04.b6a9f8ce.jpg";